import * as defaultImport from "@splunk/react-ui/ButtonSimple";
export * from "@splunk/react-ui/ButtonSimple";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
